import {PartnerIdentity} from './partner.model';
import {DictionaryItem} from './dictionary.model';

export class Transcoder {
    id: number;
    partners: PartnerIdentity[];
    assortmentGroup: DictionaryItem;
    assortmentSubgroup: DictionaryItem;
    brandModelDefined?: boolean;
    index: string;
    brand: string;
    model: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class TranscoderSimple {
    index: string;
    assortmentGroup: DictionaryItem;
    assortmentSubgroup: DictionaryItem;
    brand: string;
    model: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
